//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as commonModule } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services'
import { OPERATOR_SERVICE_NAME, OperatorService } from '../../services/operator'
import {
    SYSTEM_SERVICE_PROVIDER_NAME,
    $STATE_SERVICE_PROVIDER_NAME,
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    SystemServiceProvider,
    SystemService,
    SYSTEM_SERVICE_NAME
} from '../../services/system'
import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, UserSessionServiceProvider, UserSessionService } from '../../services/user-session'
import { GRID_CONTEXT_MENU_SERVICE_NAME, GridContextMenuService } from '../../services/grid'

import { ScopeBaseGrid } from '../common/common.base.grid.controller'

import { OperatorsController } from './operators.controller'

import { COMPONENTS_MODULE_NAME, DETAILS_DIRECTIVE_NAME } from './components'

//#region Asset Imports

import * as TEMPLATE from './operators.tpl.html'

//#endregion


// Consts

const CONTROLER_NAME: string = 'OperatorsController'
const MODULE_NAME: string = 'simax.operators'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'OPERATOR_NAME'
const MENU_INDEX: number = 5
const STATE_NAME: string = 'operators'
const STATE_URL: string = '/operators'

// Consts End


// Setup 

const module = angular.module(MODULE_NAME, [
    commonModule,
    apiModule,
    SERVICES_MODULE_NAME,
    COMPONENTS_MODULE_NAME
])

module.controller(CONTROLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    OPERATOR_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: ScopeBaseGrid,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSessionService: UserSessionService,
        operatorService: OperatorService,
        systemService: SystemService
    ) => new OperatorsController(
        $scope,
        $state,
        $timeout,
        api,
        localDictionary,
        gridContextMenuService,
        userSessionService,
        operatorService,
        systemService,
        OperatorService.REFERENCE_TYPE,
        OperatorService.SIMAX_MODULE_NAME
    )])

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionServiceProvider: UserSessionServiceProvider,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Operator_IdOperator',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionServiceProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.OPERATOR_LIST)
                && !loggedOperator.hasPermission(Activity.OPERATOR_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.OperatorModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.USERS),
                    'operators',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End

export default MODULE_NAME
